import React, { useState } from 'react'

import isNil from 'lodash/isNil'

import Button from 'components/ui/button'

type IAttribute = {
  name: string
  shortName: string
  icon: string
}

export interface IResult {
  id: string
  title: string
  description: string
  attributes?: IAttribute[]
  image?: string
  onClick?: (id: string) => void
}

export const ResultElement: React.FC<IResult> = (props) => {
  const { id, title, description, attributes, image } = props
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleClick = () => {
    if (props.onClick && !isLoading) {
      setIsLoading(true)
      props.onClick(id)
    }
  }
  return (
    <div className="w-full flex justify-between bg-gray-100 p-25 mt-10 first-child:mt-0">
      <div className="w-9/12">
        <h3 className="font-400 text-black text-20 tracking-0.23 mb-15 last-child:mb-0">{title}</h3>
        <p className="font-400 text-black text-13 tracking-0.1 mb-25 last-child:mb-0">
          {description}
        </p>
        <ul>
          {attributes &&
            attributes.map((attr: IAttribute, index: number) => {
              return (
                <div key={index} className="flex align-center mb-7 last-child:mb-0">
                  {!isNil(attr.icon) && (
                    <div
                      style={{
                        height: 17,
                        width: 17,
                      }}
                      className="mr-10"
                      dangerouslySetInnerHTML={{ __html: attr.icon }}
                    />
                  )}

                  <div className="self-center">
                    <li className="font-500 text-black text-10 tracking-1.5 uppercase">
                      {attr.name}
                    </li>
                  </div>
                </div>
              )
            })}
        </ul>
      </div>
      <div className="flex flex-col w-3/12 justify-between ml-65">
        {image ? (
          <img src={image} alt={`${title} ${description}`} />
        ) : (
          <div style={{ paddingTop: '100%' }} className="relative w-full bg-gray-200 mb-15"></div>
        )}
        <div className={`flex justify-end ${image && 'mt-15'}`}>
          <Button isLoading={isLoading} primary onClick={handleClick}>
            Kalkulieren
          </Button>
        </div>
      </div>
    </div>
  )
}
